'use client';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useState, useRef, useEffect } from 'react';
import { Box } from '@s7/base';
import { useMergedRefs } from '@s7/hooks';
import { isString } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const loadingStyles = {
    // высота и ширина должны быть > 4px, для lazy-loading'а
    height: '10px !important',
    width: '10px !important',
    position: 'absolute',
    zIndex: -10,
    opacity: 0,
    pointerEvents: 'none',
    userSelect: 'none'
};
const filterStyles = {
    filter: 'blur(4px)'
};
/** Отображает preview-картинку, пока основная подгружается. */ const ImageWithPreview = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { preview, children, onLoad } = props, others = _object_without_properties_loose(props, [
        "preview",
        "children",
        "onLoad"
    ]);
    const [isLoading, setIsLoading] = useState(true);
    const loadingRef = useRef(null);
    const handleLoad = (event)=>{
        onLoad == null ? void 0 : onLoad(event);
        if (event == null ? void 0 : event.defaultPrevented) {
            return;
        }
        setIsLoading(false);
    };
    useEffect(()=>{
        var _loadingRef_current;
        if ((_loadingRef_current = loadingRef.current) == null ? void 0 : _loadingRef_current.complete) {
            setIsLoading(false);
        }
    });
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            isLoading && preview && (isString(preview) ? /*#__PURE__*/ jsx(Box, {
                alt: others.alt,
                as: "img",
                className: others.className,
                height: others.height,
                id: others.id,
                src: preview,
                style: _extends({}, filterStyles, others.style),
                sx: others.sx,
                width: others.width
            }) : preview),
            /*#__PURE__*/ jsx(Box, _extends({
                ref: useMergedRefs(ref, loadingRef)
            }, others, {
                alt: others.alt,
                as: "img",
                style: isLoading ? loadingStyles : others.style,
                onLoad: handleLoad
            })),
            !isLoading && children
        ]
    });
});

export { ImageWithPreview };
//# sourceMappingURL=ImageWithPreview.js.map
